import React, { useEffect, useRef, useState } from "react";
import LOGO from "../assets/images/logo-space.png";

import About from "./About";
import WebsiteDev from "./WebsiteDev";
import ContactMe from "./ContactMe";
import VerticalNavigation from "../components/VerticalNavigation";
import SlideImageDesign from "../components/SlideImageDesign";
import { MenuOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Dropdown, Space } from "antd";

const Home = () => {
  const [activeButton, setActiveButton] = useState<string>("");
  const refAbout = useRef<any>(null);
  const refDev = useRef<any>(null);
  const refDesign = useRef<any>(null);
  const refContact = useRef<any>(null);

  const onClickScroll = (segment: string) => {
    switch (segment) {
      case "about":
        return refAbout.current?.scrollIntoView({ behavior: "smooth" });
      case "dev":
        return refDev.current?.scrollIntoView({ behavior: "smooth" });
      case "design":
        return refDesign.current?.scrollIntoView({ behavior: "smooth" });
      case "contact":
        return refContact.current?.scrollIntoView({ behavior: "smooth" });
      default:
        break;
    }

    setTimeout(() => {
      setActiveButton(segment);
    }, 800);
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    const callback = (entries: any, observer: any) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          if (entry.target === refAbout.current) {
            setActiveButton("about");
          } else if (entry.target === refDev.current) {
            setActiveButton("dev");
          } else if (entry.target === refDesign.current) {
            setActiveButton("design");
          } else if (entry.target === refContact.current) {
            setActiveButton("contact");
          }
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    // เริ่มตรวจสอบการ scroll สำหรับทุก ref
    if (refAbout.current) {
      observer.observe(refAbout.current);
    }
    if (refDev.current) {
      observer.observe(refDev.current);
    }
    if (refDesign.current) {
      observer.observe(refDesign.current);
    }
    if (refContact.current) {
      observer.observe(refContact.current);
    }

    return () => {
      // หยุดตรวจสอบการ scroll เมื่อคอมโพเนนต์ถูก unmount
      observer.disconnect();
    };
  }, []);

  const items: MenuProps["items"] = [
    {
      label: (
        <div>
          <ul className="text-right flex flex-col gap-[3px] text-custom-gray-75 ">
            <li
              className="bg-white px-[10px] rounded-[5px] hover:bg-custom-primary-100 duration-200 hover:text-white"
              onClick={() => onClickScroll("about")}
            >
              about
            </li>
            <li
              className="bg-white px-[10px] rounded-[5px] hover:bg-custom-primary-100 duration-200 hover:text-white"
              onClick={() => onClickScroll("dev")}
            >
              dev
            </li>
            <li
              className="bg-white px-[10px] rounded-[5px] hover:bg-custom-primary-100 duration-200 hover:text-white"
              onClick={() => onClickScroll("design")}
            >
              design
            </li>
            <li
              className="bg-white px-[10px] rounded-[5px] hover:bg-custom-primary-100 duration-200 hover:text-white"
              onClick={() => onClickScroll("contact")}
            >
              contact
            </li>
          </ul>
        </div>
      ),
      key: "0",
    },
  ];

  return (
    <div className="flex flex-col w-full items-center overflow-hidden ">
      <VerticalNavigation
        onClickScroll={onClickScroll}
        stateActive={activeButton}
      />
      <div className="flex flex-col max-w-[1280px] w-full sm:px-[15px]">
        <div className="flex flex-row wi justify-between my-[25px]">
          <div className="flex flex-row gap-[10px]">
            <img src={LOGO} className="w-[50px] rounded-[10px]" />
            <div>
              <p className="mb-0 text-base font-bold text-custom-gray-100">
                WATCHARAPOL
              </p>
              <p className="mb-0 text-base text-custom-gray-75">Web Profile</p>
            </div>
          </div>

          <div>
            <ul className="flex gap-[30px] text-sm xs:hidden">
              <li
                onClick={() => onClickScroll("about")}
                className="cursor-pointer"
              >
                ABOUT
              </li>
              <li
                onClick={() => onClickScroll("dev")}
                className="cursor-pointer"
              >
                DEV
              </li>
              <li
                onClick={() => onClickScroll("design")}
                className="cursor-pointer"
              >
                DESIGN
              </li>
              <li
                onClick={() => onClickScroll("contact")}
                className="cursor-pointer"
              >
                CONTACT
              </li>
            </ul>
          </div>

          <div
            className="hidden  rounded-[100px] xs:flex  
          fixed z-[99] backdrop-blur-sm  bg-custom-primary-100/60 text-white 
          right-[15px] hover:bg-custom-primary-75/80 cursor-pointer 
          "
          >
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              className="[&_.ant-dropdown-menu]:!bg-custom-primary-100 h-[35px] w-[35px] justify-center items-center flex"
              rootClassName="[&_.ant-dropdown-menu]:!bg-white/0 [&_.ant-dropdown-menu]:!shadow-none [&_.ant-dropdown-menu-item]:hover:!bg-white/0"
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <MenuOutlined />
                </Space>
              </a>
            </Dropdown>
          </div>
        </div>
        <div ref={refAbout}>
          <About />
        </div>

        <div ref={refDev}>
          <WebsiteDev />
        </div>
        <div ref={refDesign} className="h-[900px] mb-[200px] sx:h-[500px]">
          <SlideImageDesign />
        </div>
      </div>
      <div
        className="bg-custom-gray-75 pt-[100px] flex flex-col w-full items-center"
        ref={refContact}
      >
        <ContactMe />
      </div>
    </div>
  );
};

export default Home;
